import moment from 'moment';

export default function formatDate(d, format = 'short') {
  let f;

  switch (format) {
    case 'short':
      f = 'MMMM DD, YYYY';
      break;

    default:
      f = 'MMMM/DD/YYYY';
      break;
  }

  return moment(d).format(f);
}
